(function frameConfiguratorBundle(globalScope) {
  'use strict';

  const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it'];

  const COPY = {
    de: {
      profileEyebrow: 'Schritt 1 · Rahmentyp',
      profileTitle: 'Schattenfugenrahmen',
      profileText: 'Passend für Leinwände und Keilrahmen bis 2 cm Tiefe.',
      stepWidth: 'Schritt 2 · Breite',
      stepHeight: 'Schritt 3 · Höhe',
      popularFormats: 'Beliebte Formate',
      formatHelp: 'Gib das Format deiner Leinwand ein. Hoch- und Querformat verwenden denselben Rahmen.',
      widthCm: 'Breite in Zentimetern',
      heightCm: 'Höhe in Zentimetern',
      decrease: 'Wert verkleinern',
      increase: 'Wert vergrössern',
      resultTitle: 'Dein passender Rahmen',
      previewTitle: 'Vorschau',
      galleryLabel: 'Produktansichten',
      openImage: 'Produktbild vergrössern',
      closeImage: 'Vergrösserte Ansicht schliessen',
      previousImage: 'Vorheriges Produktbild',
      nextImage: 'Nächstes Produktbild',
      enlargedImage: 'Vergrösserte Produktansicht',
      photoPerspective: 'Schattenfugenrahmen mit Leinwand in Perspektivansicht',
      photoWithCanvas: 'Detailansicht des Schattenfugenrahmens mit eingesetzter Leinwand',
      photoFront: 'Schattenfugenrahmen aus Rohholz in Frontalansicht',
      photoRear: 'Eck- und Verbindungsdetail auf der Rückseite des Schattenfugenrahmens',
      canvas: 'Leinwand',
      shadowGap: 'Schattenfuge',
      productFormat: 'Für Leinwandformat',
      finish: 'Oberfläche',
      raw: 'Roh, individuell übermalbar',
      sku: 'Artikelnummer',
      availability: 'Verfügbarkeit',
      inStock: 'Bestellbar',
      outOfStock: 'Zurzeit nicht verfügbar',
      deliveryDate: 'Voraussichtlicher Liefertermin',
      deliveryHelp: 'Das Datum zeigt, wann die Lieferung voraussichtlich bei Ihnen eintrifft. Produktion, Abwicklung und Versand sind bereits einberechnet.',
      availableByStock: 'Nach Verfügbarkeit',
      deliveryUnavailable: 'Liefertermin aktuell nicht verbunden',
      deliveryReload: 'Liefertermin bitte kurz neu laden',
      deliveryLoading: 'Wird berechnet …',
      productDescription: 'Produktbeschreibung',
      descriptionTemplate: 'Der FLEURY Schattenfugenrahmen im Format {format} verleiht deinem Leinwandbild eine professionelle, schwebende Wirkung. Die ca. 3–5 mm breite Schattenfuge lässt das Motiv vollständig sichtbar und setzt es plastisch vom Rahmen ab.\n\nDer Bausatz besteht aus vier passgenauen Leisten aus astfreiem Abachi-Holz. Das Holz wird roh geliefert und kann nach Wunsch grundiert, bemalt oder veredelt werden. Dank Stecksystem ist der Rahmen in wenigen Minuten montiert; Schrauben, Befestigungsmaterial und zwei Zackenaufhänger sind enthalten. Geeignet für Leinwände und Keilrahmen bis 2 cm Tiefe.',
      benefits: 'Vorteile',
      freeDelivery: 'Gratis Lieferung',
      invoiceOrCard: 'Zahlung per Rechnung oder Karte',
      price: 'Preis',
      quantity: 'Menge',
      addToCart: 'In den Warenkorb',
      adding: 'Wird hinzugefügt …',
      added: 'Der Rahmen ist im Warenkorb.',
      goToCart: 'Zum Warenkorb',
      viewProduct: 'Produkt ansehen',
      share: 'Teilen',
      shareTitle: 'Auswahl teilen',
      shareWhatsApp: 'WhatsApp',
      shareEmail: 'E-Mail',
      shareCopy: 'Link kopieren',
      sharePreparing: 'Link wird vorbereitet …',
      shareCopied: 'Link kopiert.',
      shareSubject: 'FLEURY Rahmen-Auswahl',
      shareDescription: 'Die ausgewählte FLEURY Schattenfugenrahmen-Konfiguration direkt ansehen.',
      shareWhatsAppOpening: 'WhatsApp wird geöffnet …',
      shareEmailPreparing: 'E-Mail wird vorbereitet …',
      sharePrepareFailed: 'Der Link konnte nicht vorbereitet werden.',
      shareManualCopy: 'Link manuell kopieren:',
      cartError: 'Der Rahmen konnte nicht in den Warenkorb gelegt werden.',
      noMatchTitle: 'Kein Standardrahmen gefunden',
      noMatchText: 'Für dieses Format gibt es in der gewählten Kollektion keinen Lagerartikel.',
      emptyTitle: 'Keine Rahmen gefunden',
      emptyText: 'Bitte wähle im Theme-Editor die Shopify-Kollektion mit den Schattenfugenrahmen.',
      loading: 'Passenden Rahmen suchen …',
      cm: 'cm'
    },
    en: {
      profileEyebrow: 'Step 1 · Frame type',
      profileTitle: 'Floating frame',
      profileText: 'Suitable for canvases and stretcher frames up to 2 cm deep.',
      stepWidth: 'Step 2 · Width',
      stepHeight: 'Step 3 · Height',
      popularFormats: 'Popular sizes',
      formatHelp: 'Enter the size of your canvas. Portrait and landscape use the same frame.',
      widthCm: 'Width in centimetres',
      heightCm: 'Height in centimetres',
      decrease: 'Decrease value',
      increase: 'Increase value',
      resultTitle: 'Your matching frame',
      previewTitle: 'Preview',
      galleryLabel: 'Product views',
      openImage: 'Enlarge product image',
      closeImage: 'Close enlarged view',
      previousImage: 'Previous product image',
      nextImage: 'Next product image',
      enlargedImage: 'Enlarged product view',
      photoPerspective: 'Floating frame with canvas in perspective view',
      photoWithCanvas: 'Close-up of the floating frame with an inserted canvas',
      photoFront: 'Raw wood floating frame in front view',
      photoRear: 'Rear corner and joint detail of the floating frame',
      canvas: 'Canvas',
      shadowGap: 'Shadow gap',
      productFormat: 'For canvas size',
      finish: 'Finish',
      raw: 'Raw, ready to be painted',
      sku: 'SKU',
      availability: 'Availability',
      inStock: 'Available to order',
      outOfStock: 'Currently unavailable',
      deliveryDate: 'Estimated delivery date',
      deliveryHelp: 'This date shows when delivery is expected to arrive. Production, handling and shipping are included.',
      availableByStock: 'Subject to availability',
      deliveryUnavailable: 'Delivery date is not connected',
      deliveryReload: 'Please reload to update the delivery date',
      deliveryLoading: 'Calculating …',
      productDescription: 'Product description',
      descriptionTemplate: 'The FLEURY floating frame in size {format} gives your canvas a professional, floating appearance. The approx. 3–5 mm shadow gap keeps the entire motif visible and adds depth to the artwork.\n\nThe kit consists of four precisely cut strips of knot-free abachi wood. The wood is supplied raw and can be primed, painted or finished as desired. Thanks to the plug-in system, the frame is assembled in a few minutes; screws, mounting hardware and two sawtooth hangers are included. Suitable for canvases and stretcher frames up to 2 cm deep.',
      benefits: 'Benefits',
      freeDelivery: 'Free delivery',
      invoiceOrCard: 'Pay by invoice or card',
      price: 'Price',
      quantity: 'Quantity',
      addToCart: 'Add to cart',
      adding: 'Adding …',
      added: 'The frame is in your cart.',
      goToCart: 'View cart',
      viewProduct: 'View product',
      share: 'Share',
      shareTitle: 'Share selection',
      shareWhatsApp: 'WhatsApp',
      shareEmail: 'E-mail',
      shareCopy: 'Copy link',
      sharePreparing: 'Preparing link …',
      shareCopied: 'Link copied.',
      shareSubject: 'FLEURY frame selection',
      shareDescription: 'View the selected FLEURY floating-frame configuration directly.',
      shareWhatsAppOpening: 'Opening WhatsApp …',
      shareEmailPreparing: 'Preparing e-mail …',
      sharePrepareFailed: 'The link could not be prepared.',
      shareManualCopy: 'Copy the link manually:',
      cartError: 'The frame could not be added to the cart.',
      noMatchTitle: 'No standard frame found',
      noMatchText: 'There is no stock item for this size in the selected collection.',
      emptyTitle: 'No frames found',
      emptyText: 'Select the Shopify floating-frame collection in the theme editor.',
      loading: 'Finding the matching frame …',
      cm: 'cm'
    },
    fr: {
      profileEyebrow: 'Étape 1 · Type de cadre',
      profileTitle: 'Caisse américaine',
      profileText: 'Pour toiles et châssis jusqu’à 2 cm de profondeur.',
      stepWidth: 'Étape 2 · Largeur',
      stepHeight: 'Étape 3 · Hauteur',
      popularFormats: 'Formats populaires',
      formatHelp: 'Indiquez le format de votre toile. Le portrait et le paysage utilisent le même cadre.',
      widthCm: 'Largeur en centimètres',
      heightCm: 'Hauteur en centimètres',
      decrease: 'Diminuer la valeur',
      increase: 'Augmenter la valeur',
      resultTitle: 'Le cadre correspondant',
      previewTitle: 'Aperçu',
      galleryLabel: 'Vues du produit',
      openImage: 'Agrandir l’image du produit',
      closeImage: 'Fermer la vue agrandie',
      previousImage: 'Image précédente',
      nextImage: 'Image suivante',
      enlargedImage: 'Vue agrandie du produit',
      photoPerspective: 'Caisse américaine avec toile en vue perspective',
      photoWithCanvas: 'Détail de la caisse américaine avec une toile insérée',
      photoFront: 'Caisse américaine en bois brut vue de face',
      photoRear: 'Détail arrière de l’angle et de l’assemblage de la caisse américaine',
      canvas: 'Toile',
      shadowGap: 'Joint creux',
      productFormat: 'Pour toile au format',
      finish: 'Finition',
      raw: 'Brut, à peindre selon vos envies',
      sku: 'Référence',
      availability: 'Disponibilité',
      inStock: 'Disponible à la commande',
      outOfStock: 'Actuellement indisponible',
      deliveryDate: 'Date de livraison estimée',
      deliveryHelp: 'La date indique quand la livraison devrait arriver. Production, préparation et expédition sont incluses.',
      availableByStock: 'Selon disponibilité',
      deliveryUnavailable: 'Date de livraison non connectée',
      deliveryReload: 'Veuillez recharger pour actualiser la date de livraison',
      deliveryLoading: 'Calcul en cours …',
      productDescription: 'Description du produit',
      descriptionTemplate: 'La caisse américaine FLEURY au format {format} donne à votre toile un aspect professionnel et flottant. Le joint creux d’environ 3 à 5 mm laisse le motif entièrement visible et apporte davantage de profondeur à l’œuvre.\n\nLe kit se compose de quatre baguettes ajustées en bois d’abachi sans nœuds. Le bois est livré brut et peut être apprêté, peint ou personnalisé. Grâce au système d’emboîtement, le cadre se monte en quelques minutes ; les vis, le matériel de fixation et deux attaches dentées sont inclus. Convient aux toiles et châssis jusqu’à 2 cm de profondeur.',
      benefits: 'Avantages',
      freeDelivery: 'Livraison gratuite',
      invoiceOrCard: 'Paiement sur facture ou par carte',
      price: 'Prix',
      quantity: 'Quantité',
      addToCart: 'Ajouter au panier',
      adding: 'Ajout en cours …',
      added: 'Le cadre est dans votre panier.',
      goToCart: 'Voir le panier',
      viewProduct: 'Voir le produit',
      share: 'Partager',
      shareTitle: 'Partager la sélection',
      shareWhatsApp: 'WhatsApp',
      shareEmail: 'E-mail',
      shareCopy: 'Copier le lien',
      sharePreparing: 'Préparation du lien …',
      shareCopied: 'Lien copié.',
      shareSubject: 'Sélection de cadre FLEURY',
      shareDescription: 'Voir directement la configuration de caisse américaine FLEURY sélectionnée.',
      shareWhatsAppOpening: 'Ouverture de WhatsApp …',
      shareEmailPreparing: 'Préparation de l’e-mail …',
      sharePrepareFailed: 'Impossible de préparer le lien.',
      shareManualCopy: 'Copier le lien manuellement :',
      cartError: 'Le cadre n’a pas pu être ajouté au panier.',
      noMatchTitle: 'Aucun cadre standard trouvé',
      noMatchText: 'Aucun article de stock ne correspond à ce format dans la collection.',
      emptyTitle: 'Aucun cadre trouvé',
      emptyText: 'Sélectionnez la collection Shopify des caisses américaines dans l’éditeur de thème.',
      loading: 'Recherche du cadre correspondant …',
      cm: 'cm'
    },
    it: {
      profileEyebrow: 'Passaggio 1 · Tipo di cornice',
      profileTitle: 'Cornice a cassetta',
      profileText: 'Adatta a tele e telai con profondità fino a 2 cm.',
      stepWidth: 'Passaggio 2 · Larghezza',
      stepHeight: 'Passaggio 3 · Altezza',
      popularFormats: 'Formati più richiesti',
      formatHelp: 'Inserisci il formato della tela. Verticale e orizzontale usano la stessa cornice.',
      widthCm: 'Larghezza in centimetri',
      heightCm: 'Altezza in centimetri',
      decrease: 'Riduci valore',
      increase: 'Aumenta valore',
      resultTitle: 'La cornice adatta',
      previewTitle: 'Anteprima',
      galleryLabel: 'Viste del prodotto',
      openImage: 'Ingrandisci l’immagine del prodotto',
      closeImage: 'Chiudi la vista ingrandita',
      previousImage: 'Immagine precedente',
      nextImage: 'Immagine successiva',
      enlargedImage: 'Vista ingrandita del prodotto',
      photoPerspective: 'Cornice a cassetta con tela vista in prospettiva',
      photoWithCanvas: 'Dettaglio della cornice a cassetta con tela inserita',
      photoFront: 'Cornice a cassetta in legno grezzo vista frontale',
      photoRear: 'Dettaglio posteriore dell’angolo e della giunzione della cornice',
      canvas: 'Tela',
      shadowGap: 'Fuga',
      productFormat: 'Per tela formato',
      finish: 'Finitura',
      raw: 'Grezza, personalizzabile con colore',
      sku: 'Codice articolo',
      availability: 'Disponibilità',
      inStock: 'Ordinabile',
      outOfStock: 'Al momento non disponibile',
      deliveryDate: 'Data di consegna prevista',
      deliveryHelp: 'La data indica quando è prevista la consegna. Produzione, preparazione e spedizione sono incluse.',
      availableByStock: 'Secondo disponibilità',
      deliveryUnavailable: 'Data di consegna non collegata',
      deliveryReload: 'Ricarica la pagina per aggiornare la data di consegna',
      deliveryLoading: 'Calcolo in corso …',
      productDescription: 'Descrizione del prodotto',
      descriptionTemplate: 'La cornice a cassetta FLEURY nel formato {format} dona alla tela un effetto professionale e sospeso. La fuga di circa 3–5 mm lascia il soggetto completamente visibile e conferisce maggiore profondità all’opera.\n\nIl kit è composto da quattro listelli su misura in legno di abachi privo di nodi. Il legno viene fornito grezzo e può essere preparato, dipinto o rifinito a piacere. Grazie al sistema a incastro, la cornice si monta in pochi minuti; sono incluse viti, materiale di fissaggio e due attaccaglie dentate. Adatta a tele e telai fino a 2 cm di profondità.',
      benefits: 'Vantaggi',
      freeDelivery: 'Consegna gratuita',
      invoiceOrCard: 'Pagamento con fattura o carta',
      price: 'Prezzo',
      quantity: 'Quantità',
      addToCart: 'Aggiungi al carrello',
      adding: 'Aggiunta in corso …',
      added: 'La cornice è nel carrello.',
      goToCart: 'Vai al carrello',
      viewProduct: 'Vedi prodotto',
      share: 'Condividi',
      shareTitle: 'Condividi selezione',
      shareWhatsApp: 'WhatsApp',
      shareEmail: 'E-mail',
      shareCopy: 'Copia link',
      sharePreparing: 'Preparazione del link …',
      shareCopied: 'Link copiato.',
      shareSubject: 'Selezione cornice FLEURY',
      shareDescription: 'Visualizza direttamente la configurazione della cornice a cassetta FLEURY selezionata.',
      shareWhatsAppOpening: 'Apertura di WhatsApp …',
      shareEmailPreparing: 'Preparazione dell’e-mail …',
      sharePrepareFailed: 'Impossibile preparare il link.',
      shareManualCopy: 'Copia manualmente il link:',
      cartError: 'Non è stato possibile aggiungere la cornice al carrello.',
      noMatchTitle: 'Nessuna cornice standard trovata',
      noMatchText: 'Nella collezione selezionata non esiste un articolo standard per questo formato.',
      emptyTitle: 'Nessuna cornice trovata',
      emptyText: 'Seleziona la collezione Shopify delle cornici nell’editor del tema.',
      loading: 'Ricerca della cornice adatta …',
      cm: 'cm'
    }
  };

  function normalizeLocale(locale) {
    const shortLocale = String(locale || 'de').trim().toLowerCase().split(/[-_]/)[0];
    return SUPPORTED_LOCALES.includes(shortLocale) ? shortLocale : 'de';
  }

  function translate(locale, key, overrides) {
    const safeLocale = normalizeLocale(locale);
    const override = overrides && typeof overrides[key] === 'string' ? overrides[key].trim() : '';
    return override || COPY[safeLocale][key] || COPY.de[key] || key;
  }

  function applyDescriptionTemplate(template, values) {
    const source = String(template || '').trim();
    const replacements = values && typeof values === 'object' ? values : {};
    return source.replace(/\{(name|format)\}/g, (_match, placeholder) => (
      replacements[placeholder] == null ? '' : String(replacements[placeholder])
    )).trim();
  }

  function toPositiveInteger(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  }

  function validDimension(value) {
    return Number.isFinite(value) && value >= 10 && value <= 400;
  }

  function dimensions(width, height) {
    const safeWidth = toPositiveInteger(width);
    const safeHeight = toPositiveInteger(height);
    if (!validDimension(safeWidth) || !validDimension(safeHeight)) return null;
    return { width: safeWidth, height: safeHeight };
  }

  function parseTitleDimensions(title) {
    const match = String(title || '').match(/(\d{2,3})\s*[x×]\s*(\d{2,3})\s*(?:cm)?/i);
    return match ? dimensions(match[1], match[2]) : null;
  }

  function parseSkuDimensions(sku) {
    const source = String(sku || '').trim();
    const labelled = source.match(/(?:SF|SR|RAHMEN)[+\s_-]*(\d{2,3})[x×/_-](\d{2,3})/i);
    if (labelled) return dimensions(labelled[1], labelled[2]);

    const compact = source.match(/^SF\+?(\d{5,6})(?:\D|$)/i);
    if (!compact) return null;

    const digits = compact[1];
    const split = digits.length === 6 ? 3 : 2;
    return dimensions(digits.slice(0, split), digits.slice(split));
  }

  function extractDimensions(item) {
    const explicit = dimensions(item && item.widthCm, item && item.heightCm);
    return explicit
      || parseTitleDimensions(`${item && item.productTitle || ''} ${item && item.variantTitle || ''}`)
      || parseSkuDimensions(item && item.sku);
  }

  function formatKey(width, height) {
    const shortSide = Math.min(toPositiveInteger(width), toPositiveInteger(height));
    const longSide = Math.max(toPositiveInteger(width), toPositiveInteger(height));
    return `${shortSide}x${longSide}`;
  }

  function isFrameProduct(item) {
    const title = `${item && item.productTitle || ''} ${item && item.variantTitle || ''}`.toLowerCase();
    const type = String(item && item.productType || '').toLowerCase();
    const sku = String(item && item.sku || '').toUpperCase();

    if (title.includes('dekostreifen') || title.includes('deko-streifen')) return false;
    if (type.includes('zubehör') || type.includes('zubehoer') || type.includes('accessor')) return false;
    return title.includes('schattenfugen')
      || type.includes('schattenfugen')
      || sku.startsWith('SF+');
  }

  function normalizeFrameItems(items) {
    const records = [];
    const seenVariants = new Set();

    (Array.isArray(items) ? items : []).forEach((item) => {
      if (!item || !isFrameProduct(item)) return;
      const frameDimensions = extractDimensions(item);
      if (!frameDimensions) return;

      const id = String(item.id || '').trim();
      if (!id || seenVariants.has(id)) return;
      seenVariants.add(id);

      records.push({
        ...item,
        id,
        widthCm: frameDimensions.width,
        heightCm: frameDimensions.height,
        shortSide: Math.min(frameDimensions.width, frameDimensions.height),
        longSide: Math.max(frameDimensions.width, frameDimensions.height),
        formatKey: formatKey(frameDimensions.width, frameDimensions.height),
        available: item.available === true || item.available === 'true',
        inventoryQuantity: Number.parseInt(item.inventoryQuantity, 10) || 0,
        price: Math.max(0, Number.parseInt(item.price, 10) || 0),
        compareAtPrice: Math.max(0, Number.parseInt(item.compareAtPrice, 10) || 0)
      });
    });

    return records.sort((left, right) => (
      left.shortSide - right.shortSide
      || left.longSide - right.longSide
      || Number(right.available) - Number(left.available)
      || left.price - right.price
    ));
  }

  function availableCombos(items) {
    const combos = [];
    const seen = new Set();

    (Array.isArray(items) ? items : []).forEach((item) => {
      [
        { width: item.widthCm, height: item.heightCm },
        { width: item.heightCm, height: item.widthCm }
      ].forEach((combo) => {
        const key = `${combo.width}x${combo.height}`;
        if (!seen.has(key)) {
          seen.add(key);
          combos.push(combo);
        }
      });
    });

    return combos.sort((left, right) => left.width - right.width || left.height - right.height);
  }

  function axisOptions(combos, axis, state) {
    const safeCombos = Array.isArray(combos) ? combos : [];
    const source = axis === 'height'
      ? safeCombos.filter((combo) => toPositiveInteger(combo.width) === toPositiveInteger(state && state.width))
      : safeCombos;
    return [...new Set(source.map((combo) => toPositiveInteger(combo[axis])).filter(Boolean))]
      .sort((left, right) => left - right);
  }

  function nearestValue(value, values) {
    const safeValues = Array.isArray(values) ? values.filter(Number.isFinite) : [];
    if (!safeValues.length) return 0;
    return safeValues.reduce((nearest, candidate) => (
      Math.abs(candidate - value) < Math.abs(nearest - value) ? candidate : nearest
    ), safeValues[0]);
  }

  function nearestCombo(width, height, combos) {
    const safeCombos = Array.isArray(combos) ? combos : [];
    if (!safeCombos.length) return null;
    return safeCombos.reduce((nearest, combo) => {
      const distance = Math.abs(combo.width - width) + Math.abs(combo.height - height);
      const nearestDistance = Math.abs(nearest.width - width) + Math.abs(nearest.height - height);
      return distance < nearestDistance ? combo : nearest;
    }, safeCombos[0]);
  }

  function findFrame(items, width, height) {
    const key = formatKey(width, height);
    return (Array.isArray(items) ? items : [])
      .filter((item) => item.formatKey === key)
      .sort((left, right) => Number(right.available) - Number(left.available) || left.price - right.price)[0] || null;
  }

  function parseQuickSizes(value) {
    const seen = new Set();
    return String(value || '')
      .split(/[,;\n]+/)
      .map((entry) => entry.trim().match(/^(\d{2,3})\s*[x×]\s*(\d{2,3})$/i))
      .filter(Boolean)
      .map((match) => ({ width: Number.parseInt(match[1], 10), height: Number.parseInt(match[2], 10) }))
      .filter((size) => {
        const key = `${size.width}x${size.height}`;
        if (!validDimension(size.width) || !validDimension(size.height) || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  }

  function parseSharedFrameState(search, combos) {
    let params;
    try {
      params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
    } catch {
      return null;
    }

    const width = Number.parseInt(params.get('fc_width'), 10);
    const height = Number.parseInt(params.get('fc_height'), 10);
    if (!Number.isInteger(width) || !Number.isInteger(height)) return null;

    return (Array.isArray(combos) ? combos : []).find((combo) => (
      combo.width === width && combo.height === height
    )) || null;
  }

  function buildFrameShareUrl(href, state) {
    try {
      const url = new URL(String(href || ''), 'https://fleury.art/pages/rahmen-stecksystem');
      url.searchParams.delete('fc_width');
      url.searchParams.delete('fc_height');
      url.searchParams.set('fc_width', String(toPositiveInteger(state && state.width)));
      url.searchParams.set('fc_height', String(toPositiveInteger(state && state.height)));
      return url.toString();
    } catch {
      return '';
    }
  }

  function absoluteShareImageUrl(imageUrl, href) {
    const rawImageUrl = String(imageUrl || '').trim();
    if (!rawImageUrl) return '';

    try {
      const baseUrl = new URL(String(href || ''), 'https://fleury.art/pages/rahmen-stecksystem');
      if (rawImageUrl.startsWith('//')) return `${baseUrl.protocol}${rawImageUrl}`;
      return new URL(rawImageUrl, baseUrl).toString();
    } catch {
      return '';
    }
  }

  function frameShareParams(state, variantId) {
    const params = {
      fc_type: 'floating_frame',
      fc_width: toPositiveInteger(state && state.width),
      fc_height: toPositiveInteger(state && state.height)
    };
    const safeVariantId = String(variantId || '').trim();
    if (safeVariantId) params.fc_variant = safeVariantId;
    return params;
  }

  function frameSharePayload(options) {
    const input = options || {};
    return {
      locale: normalizeLocale(input.locale),
      targetUrl: buildFrameShareUrl(input.href, input.state),
      imageUrl: absoluteShareImageUrl(input.imageUrl, input.href),
      title: String(input.title || ''),
      description: String(input.description || ''),
      params: frameShareParams(input.state, input.variantId)
    };
  }

  function deliveryEstimatePayload(item, locale) {
    return {
      locale: normalizeLocale(locale),
      sku: String(item && item.sku || ''),
      thicknessCm: 2,
      productGroup: '',
      inventoryQuantity: Number.parseInt(item && item.inventoryQuantity, 10) || 0
    };
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function galleryPhotos(item, fallbackPhotos, translateAlt) {
    const productTitle = String(item && item.productTitle || '');
    const productPhotos = [];

    if (item && item.image) {
      productPhotos.push({ src: item.image, alt: productTitle });
    }
    if (item && Array.isArray(item.images)) {
      productPhotos.push(...item.images);
    }

    const sourcePhotos = productPhotos.length
      ? productPhotos
      : (Array.isArray(fallbackPhotos) ? fallbackPhotos : []);
    const seen = new Set();

    return sourcePhotos
      .map((photo) => {
        if (!photo) return null;
        const src = typeof photo === 'string' ? photo : photo.src;
        if (!src || seen.has(String(src))) return null;
        seen.add(String(src));
        const altKey = typeof photo === 'object' && photo.altKey ? photo.altKey : '';
        const translatedAlt = altKey && typeof translateAlt === 'function' ? translateAlt(altKey) : '';
        const alt = typeof photo === 'object' && photo.alt
          ? photo.alt
          : (translatedAlt || productTitle);
        return { src: String(src), alt: String(alt || productTitle) };
      })
      .filter(Boolean);
  }

  function money(cents, currency, locale) {
    const localeMap = { de: 'de-CH', en: 'en-CH', fr: 'fr-CH', it: 'it-CH' };
    try {
      return new Intl.NumberFormat(localeMap[normalizeLocale(locale)], {
        style: 'currency',
        currency: String(currency || 'CHF').toUpperCase()
      }).format((Number(cents) || 0) / 100);
    } catch {
      return `${String(currency || 'CHF').toUpperCase()} ${((Number(cents) || 0) / 100).toFixed(2)}`;
    }
  }

  function previewGeometry(width, height, maxPreviewSize = 260) {
    const safeWidth = Math.max(1, Number(width) || 1);
    const safeHeight = Math.max(1, Number(height) || 1);
    const maxSide = Math.max(safeWidth, safeHeight);
    const previewWidth = (safeWidth / maxSide) * maxPreviewSize;
    const previewHeight = (safeHeight / maxSide) * maxPreviewSize;
    const labelAspectRatio = 31 / 21;
    const labelMarketingScale = 1.65;
    const labelWidthFromFormat = previewWidth * (31 / safeWidth) * labelMarketingScale;
    const labelWidthFromHeight = previewHeight * (21 / safeHeight) * labelAspectRatio * labelMarketingScale;
    const labelWidth = Math.min(
      labelWidthFromFormat,
      labelWidthFromHeight,
      previewWidth * 0.68,
      previewHeight * 0.58 * labelAspectRatio
    );

    return {
      previewWidth,
      previewHeight,
      labelWidth,
      labelAspectRatio
    };
  }

  const HTMLElementBase = typeof globalScope.HTMLElement === 'function' ? globalScope.HTMLElement : class {};

  class FleuryFrameConfigurator extends HTMLElementBase {
    connectedCallback() {
      if (this.initialized) {
        if (this.onDocumentKeydown && globalScope.document) {
          globalScope.document.addEventListener('keydown', this.onDocumentKeydown);
        }
        if (this.onDocumentClick && globalScope.document) {
          globalScope.document.addEventListener('click', this.onDocumentClick);
        }
        return;
      }
      this.initialized = true;

      this.config = this.readConfig();
      this.locale = normalizeLocale(this.config.locale || globalScope.document && globalScope.document.documentElement.lang);
      this.items = normalizeFrameItems(this.config.items);
      this.combos = availableCombos(this.items);
      this.state = { width: 0, height: 0 };
      this.deliveryRequestIds = {};

      this.widthNumber = this.querySelector('[data-field="width-number"]');
      this.heightNumber = this.querySelector('[data-field="height-number"]');
      this.widthRange = this.querySelector('[data-field="width-range"]');
      this.heightRange = this.querySelector('[data-field="height-range"]');
      this.widthTicks = this.querySelector('[data-ticks="width"]');
      this.heightTicks = this.querySelector('[data-ticks="height"]');
      this.quickSizes = this.querySelector('[data-quick-sizes]');
      this.result = this.querySelector('[data-result]');
      this.status = this.querySelector('[data-status]');

      this.applyTranslations();
      this.initializeState();
      this.bindEvents();
      this.renderQuickSizes();
      this.syncControls();
      this.render();
    }

    disconnectedCallback() {
      if (this.onDocumentKeydown && globalScope.document) {
        globalScope.document.removeEventListener('keydown', this.onDocumentKeydown);
      }
      if (this.onDocumentClick && globalScope.document) {
        globalScope.document.removeEventListener('click', this.onDocumentClick);
      }
    }

    readConfig() {
      const node = this.querySelector('[data-frame-config]');
      if (!node) return {};
      try {
        return JSON.parse(node.textContent || '{}');
      } catch {
        return {};
      }
    }

    t(key) {
      return translate(this.locale, key, this.config.i18n);
    }

    applyTranslations() {
      this.querySelectorAll('[data-i18n]').forEach((node) => {
        const key = node.getAttribute('data-i18n');
        if (key) node.textContent = this.t(key);
      });
      this.querySelectorAll('[data-i18n-aria]').forEach((node) => {
        const key = node.getAttribute('data-i18n-aria');
        if (key) node.setAttribute('aria-label', this.t(key));
      });
      const help = this.querySelector('[data-format-help]');
      if (help) {
        help.setAttribute('aria-label', this.t('formatHelp'));
        help.setAttribute('data-help', this.t('formatHelp'));
      }
    }

    initializeState() {
      if (!this.combos.length) return;
      const requested = parseQuickSizes(this.config.defaultFormat || '30x30')[0] || { width: 30, height: 30 };
      const shared = parseSharedFrameState(globalScope.location && globalScope.location.search, this.combos);
      const initial = shared
        || this.combos.find((combo) => combo.width === requested.width && combo.height === requested.height)
        || nearestCombo(requested.width, requested.height, this.combos)
        || this.combos[0];
      this.state.width = initial.width;
      this.state.height = initial.height;
    }

    bindEvents() {
      this.querySelectorAll('[data-stepper]').forEach((button) => {
        button.addEventListener('click', () => this.step(button.dataset.stepper, Number.parseInt(button.dataset.step, 10) || 0));
      });

      [
        [this.widthRange, 'width'],
        [this.heightRange, 'height']
      ].forEach(([range, axis]) => {
        if (!range) return;
        range.addEventListener('input', () => {
          const values = axisOptions(this.combos, axis, this.state);
          const index = Math.max(0, Math.min(values.length - 1, Number.parseInt(range.value, 10) || 0));
          this.setAxis(axis, values[index]);
        });
      });

      [
        [this.widthNumber, 'width'],
        [this.heightNumber, 'height']
      ].forEach(([input, axis]) => {
        if (!input) return;
        input.addEventListener('change', () => {
          const values = axisOptions(this.combos, axis, this.state);
          this.setAxis(axis, nearestValue(Number.parseInt(input.value, 10) || 0, values));
        });
      });

      this.quickSizes && this.quickSizes.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quick-width][data-quick-height]');
        if (!button) return;
        const requested = {
          width: Number.parseInt(button.dataset.quickWidth, 10),
          height: Number.parseInt(button.dataset.quickHeight, 10)
        };
        const next = this.combos.find((combo) => combo.width === requested.width && combo.height === requested.height)
          || nearestCombo(requested.width, requested.height, this.combos);
        if (!next) return;
        this.state = { ...next };
        this.syncControls();
        this.render();
      });

      this.result && this.result.addEventListener('click', (event) => {
        const galleryButton = event.target.closest('[data-gallery-image]');
        if (galleryButton) {
          this.selectGalleryImage(galleryButton);
          return;
        }
        const galleryStep = event.target.closest('[data-gallery-step]');
        if (galleryStep) {
          this.stepGallery(galleryStep);
          return;
        }
        const galleryOpen = event.target.closest('[data-gallery-open]');
        if (galleryOpen) {
          this.openGalleryModal(galleryOpen);
          return;
        }
        const galleryClose = event.target.closest('[data-gallery-close]');
        if (galleryClose) {
          this.closeGalleryModal();
          return;
        }
        const shareOption = event.target.closest('[data-share-option]');
        if (shareOption) {
          this.handleShareOptionClick(shareOption);
          return;
        }
        const shareButton = event.target.closest('[data-share-config]');
        if (shareButton) {
          this.toggleShareWidget(shareButton);
          return;
        }
        const button = event.target.closest('[data-add-frame]');
        if (button) this.addToCart(button);
      });

      this.onDocumentKeydown = (event) => {
        if (event.key === 'Escape') {
          this.closeGalleryModal();
          this.closeShareWidgets();
        }
      };
      this.onDocumentClick = (event) => {
        if (!event.target.closest('[data-share-widget]')) this.closeShareWidgets();
      };
      if (globalScope.document) {
        globalScope.document.addEventListener('keydown', this.onDocumentKeydown);
        globalScope.document.addEventListener('click', this.onDocumentClick);
      }
    }

    step(axis, direction) {
      if (!['width', 'height'].includes(axis) || !direction) return;
      const values = axisOptions(this.combos, axis, this.state);
      if (!values.length) return;
      const current = nearestValue(this.state[axis], values);
      const currentIndex = Math.max(0, values.indexOf(current));
      const nextIndex = Math.max(0, Math.min(values.length - 1, currentIndex + direction));
      this.setAxis(axis, values[nextIndex]);
    }

    setAxis(axis, value) {
      if (!value) return;
      this.state[axis] = value;
      const partner = axis === 'width' ? 'height' : 'width';
      const partnerOptions = axisOptions(this.combos, partner, this.state);
      this.state[partner] = nearestValue(this.state[partner], partnerOptions);
      this.syncControls();
      this.render();
    }

    syncControls() {
      this.syncAxis('width', this.widthNumber, this.widthRange, this.widthTicks);
      this.syncAxis('height', this.heightNumber, this.heightRange, this.heightTicks);
      this.querySelectorAll('[data-quick-width][data-quick-height]').forEach((button) => {
        const selected = Number(button.dataset.quickWidth) === this.state.width
          && Number(button.dataset.quickHeight) === this.state.height;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    syncAxis(axis, numberInput, rangeInput, ticksTarget) {
      const values = axisOptions(this.combos, axis, this.state);
      const value = nearestValue(this.state[axis], values);
      if (numberInput) {
        numberInput.value = value || '';
        numberInput.min = values[0] || 0;
        numberInput.max = values[values.length - 1] || 0;
      }
      if (rangeInput) {
        rangeInput.min = 0;
        rangeInput.max = Math.max(0, values.length - 1);
        rangeInput.step = 1;
        rangeInput.value = Math.max(0, values.indexOf(value));
        rangeInput.disabled = values.length <= 1;
        rangeInput.setAttribute('aria-valuetext', `${value} ${this.t('cm')}`);
        this.updateSwipeCue(rangeInput);
      }
      this.renderTicks(values, ticksTarget);
    }

    renderTicks(values, target) {
      if (!target) return;
      if (!values.length) {
        target.innerHTML = '';
        return;
      }
      const labelStep = values.length <= 7 ? 1 : Math.ceil((values.length - 1) / 6);
      const majorIndexes = new Set(
        values
          .map((_value, index) => index)
          .filter((index) => index === 0 || index === values.length - 1 || index % labelStep === 0),
      );
      target.innerHTML = values.map((tickValue, index) => {
        const position = values.length === 1 ? 0 : (index / (values.length - 1)) * 100;
        const isMajor = majorIndexes.has(index);
        return `
          <span class="fa-fc__tick ${isMajor ? 'fa-fc__tick--major' : 'fa-fc__tick--minor'}" style="left:${position.toFixed(2)}%">
            <i aria-hidden="true"></i>
            ${isMajor ? `<b>${escapeHtml(tickValue)}</b>` : ''}
          </span>
        `;
      }).join('');
    }

    updateSwipeCue(rangeInput) {
      const slider = rangeInput && rangeInput.closest('.fa-fc__slider');
      if (!slider) return;
      const min = Number(rangeInput.min) || 0;
      const max = Number(rangeInput.max) || min;
      const value = Number(rangeInput.value) || min;
      const percentage = max === min ? 50 : ((value - min) / (max - min)) * 100;
      slider.style.setProperty('--fa-fc-swipe-left', `${Math.max(0, Math.min(100, percentage)).toFixed(2)}%`);
    }

    renderQuickSizes() {
      if (!this.quickSizes) return;
      const requested = parseQuickSizes(this.config.quickSizes || '20x20, 30x30, 50x70, 60x80, 100x140');
      const usable = requested.filter((size) => findFrame(this.items, size.width, size.height));
      this.quickSizes.innerHTML = usable.map((size) => `
        <button
          type="button"
          data-quick-width="${size.width}"
          data-quick-height="${size.height}"
          aria-pressed="false"
        >${size.width} × ${size.height}</button>
      `).join('');
      const group = this.quickSizes.closest('[data-quick-group]');
      if (group) group.hidden = usable.length === 0;
    }

    render() {
      if (!this.result) return;
      if (!this.items.length || !this.combos.length) {
        this.result.innerHTML = this.renderEmpty();
        return;
      }

      const item = findFrame(this.items, this.state.width, this.state.height);
      this.result.innerHTML = item ? this.renderMatch(item) : this.renderNoMatch();
    }

    renderEmpty() {
      return `
        <div class="fa-fc__empty">
          <span class="fa-fc__empty-icon" aria-hidden="true">□</span>
          <h3>${escapeHtml(this.t('emptyTitle'))}</h3>
          <p>${escapeHtml(this.t('emptyText'))}</p>
        </div>
      `;
    }

    renderNoMatch() {
      return `
        ${this.renderPreview()}
        <div class="fa-fc__empty">
          <h3>${escapeHtml(this.t('noMatchTitle'))}</h3>
          <p>${escapeHtml(this.t('noMatchText'))}</p>
        </div>
      `;
    }

    renderPreview() {
      const width = Math.max(1, this.state.width);
      const height = Math.max(1, this.state.height);
      const ratio = width / height;
      const maxPreviewSize = globalScope.innerWidth && globalScope.innerWidth <= 749 ? 230 : 260;
      const geometry = previewGeometry(width, height, maxPreviewSize);
      const photoStyle = [
        `--fa-fc-photo-width:${geometry.previewWidth.toFixed(2)}px`,
        `--fa-fc-photo-height:${geometry.previewHeight.toFixed(2)}px`,
        `--fa-fc-label-width:${geometry.labelWidth.toFixed(2)}px`
      ].join(';');
      const photoPreview = this.config.previewBlankImage
        ? `
          <div
            class="fa-fc__photo-frame"
            style="${photoStyle}"
            role="img"
            aria-label="${escapeHtml(`${this.t('previewTitle')}: ${width} × ${height} cm`)}"
          >
            <img
              class="fa-fc__photo-frame-base"
              src="${escapeHtml(this.config.previewBlankImage)}"
              alt=""
              loading="eager"
            >
            ${this.config.previewLabelImage ? `
              <span class="fa-fc__photo-label" aria-hidden="true">
                <img src="${escapeHtml(this.config.previewLabelImage)}" alt="">
              </span>
            ` : ''}
          </div>
        `
        : `
          <div class="fa-fc__frame" style="--fa-fc-ratio:${ratio.toFixed(4)}">
            <span class="fa-fc__canvas">
              <span>${escapeHtml(this.t('canvas'))}</span>
            </span>
          </div>
        `;
      return `
        <div class="fa-fc__preview">
          <div class="fa-fc__preview-head">
            <span>${escapeHtml(this.t('previewTitle'))}</span>
            <strong>${width} × ${height} cm</strong>
          </div>
          <div class="fa-fc__preview-stage">
            ${photoPreview}
          </div>
          <div class="fa-fc__preview-legend">
            <span><i class="fa-fc__legend-frame"></i>${escapeHtml(this.t('profileTitle'))}</span>
            <span><i class="fa-fc__legend-gap"></i>${escapeHtml(this.t('shadowGap'))}</span>
          </div>
        </div>
      `;
    }

    renderProductMedia(item) {
      const photos = galleryPhotos(item, this.config.framePhotos, (key) => this.t(key));

      if (!photos.length) {
        return `<div class="fa-fc__product-media"><div class="fa-fc__product-placeholder" aria-hidden="true"><span></span></div></div>`;
      }

      const main = photos[0];
      const hasMultiplePhotos = photos.length > 1;
      return `
        <div class="fa-fc__product-media fa-fc__product-gallery" data-product-gallery>
          <div class="fa-fc__gallery-stage">
            <button
              type="button"
              class="fa-fc__gallery-open"
              data-gallery-open
              aria-label="${escapeHtml(this.t('openImage'))}"
            >
              <img
                src="${escapeHtml(main.src)}"
                alt="${escapeHtml(main.alt)}"
                loading="eager"
                data-gallery-main
              >
              <span class="fa-fc__gallery-zoom" aria-hidden="true">
                <svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m15.5 15.5 5 5M10.5 7v7M7 10.5h7"></path></svg>
              </span>
            </button>
            ${hasMultiplePhotos ? `
              <button type="button" class="fa-fc__gallery-arrow fa-fc__gallery-arrow--previous" data-gallery-step="-1" aria-label="${escapeHtml(this.t('previousImage'))}">
                <span aria-hidden="true">‹</span>
              </button>
              <button type="button" class="fa-fc__gallery-arrow fa-fc__gallery-arrow--next" data-gallery-step="1" aria-label="${escapeHtml(this.t('nextImage'))}">
                <span aria-hidden="true">›</span>
              </button>
            ` : ''}
          </div>
          <div class="fa-fc__gallery-thumbs" role="group" aria-label="${escapeHtml(this.t('galleryLabel'))}">
            ${photos.map((photo, index) => `
              <button
                type="button"
                data-gallery-image
                data-gallery-src="${escapeHtml(photo.src)}"
                data-gallery-alt="${escapeHtml(photo.alt)}"
                aria-label="${escapeHtml(photo.alt)}"
                aria-pressed="${index === 0 ? 'true' : 'false'}"
                class="${index === 0 ? 'is-selected' : ''}"
              >
                <img src="${escapeHtml(photo.src)}" alt="" loading="lazy">
              </button>
            `).join('')}
          </div>
          <div
            class="fa-fc__image-modal"
            data-gallery-modal
            role="dialog"
            aria-modal="true"
            aria-label="${escapeHtml(this.t('enlargedImage'))}"
            hidden
          >
            <button type="button" class="fa-fc__image-modal-backdrop" data-gallery-close aria-label="${escapeHtml(this.t('closeImage'))}"></button>
            <div class="fa-fc__image-modal-dialog">
              <button type="button" class="fa-fc__image-modal-close" data-gallery-close aria-label="${escapeHtml(this.t('closeImage'))}">
                <span aria-hidden="true">×</span>
              </button>
              <img src="${escapeHtml(main.src)}" alt="${escapeHtml(main.alt)}" data-gallery-modal-image>
            </div>
          </div>
        </div>
      `;
    }

    selectGalleryImage(button) {
      const gallery = button && button.closest('[data-product-gallery]');
      const image = gallery && gallery.querySelector('[data-gallery-main]');
      if (!gallery || !image) return;

      image.src = button.dataset.gallerySrc || image.src;
      image.alt = button.dataset.galleryAlt || image.alt;
      gallery.querySelectorAll('[data-gallery-image]').forEach((candidate) => {
        const selected = candidate === button;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    stepGallery(button) {
      const gallery = button && button.closest('[data-product-gallery]');
      if (!gallery) return;
      const candidates = Array.from(gallery.querySelectorAll('[data-gallery-image]'));
      if (candidates.length < 2) return;
      const currentIndex = Math.max(0, candidates.findIndex((candidate) => candidate.classList.contains('is-selected')));
      const direction = Number.parseInt(button.dataset.galleryStep, 10) || 0;
      const nextIndex = (currentIndex + direction + candidates.length) % candidates.length;
      this.selectGalleryImage(candidates[nextIndex]);
      candidates[nextIndex].scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    openGalleryModal(button) {
      const gallery = button && button.closest('[data-product-gallery]');
      const mainImage = gallery && gallery.querySelector('[data-gallery-main]');
      const modal = gallery && gallery.querySelector('[data-gallery-modal]');
      const modalImage = modal && modal.querySelector('[data-gallery-modal-image]');
      if (!gallery || !mainImage || !modal || !modalImage) return;

      modalImage.src = mainImage.src;
      modalImage.alt = mainImage.alt;
      modal.hidden = false;
      this.modalTrigger = button;
      modal.querySelector('.fa-fc__image-modal-close')?.focus();
    }

    closeGalleryModal() {
      const modal = this.querySelector('[data-gallery-modal]:not([hidden])');
      if (!modal) return;
      modal.hidden = true;
      this.modalTrigger?.focus?.();
      this.modalTrigger = null;
    }

    renderProductDescription(item) {
      const configuredTemplate = String(this.config.descriptionTemplates?.[this.locale] || '').trim();
      const description = applyDescriptionTemplate(configuredTemplate || this.t('descriptionTemplate'), {
        name: item.productTitle || this.t('profileTitle'),
        format: `${item.shortSide} x ${item.longSide} cm`
      });
      const paragraphs = description
        .split(/\n{2,}/)
        .map((paragraph) => paragraph.trim())
        .filter(Boolean);
      if (!paragraphs.length) return '';

      return `
        <details class="fa-fc__description">
          <summary>${escapeHtml(this.t('productDescription'))}</summary>
          <div class="fa-fc__description-content">
            ${paragraphs.map((paragraph) => `<p>${escapeHtml(paragraph).replace(/\n/g, '<br>')}</p>`).join('')}
          </div>
        </details>
      `;
    }

    renderBenefitIcon(icon) {
      const icons = {
        delivery: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 6h11v9H3z"/><path d="M14 9h4l3 3v3h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>',
        payment: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="M3 10h18"/><path d="M7 15h5"/></svg>'
      };
      return `<span class="fa-fc__price-benefit-icon fa-fc__price-benefit-icon--${icon}">${icons[icon]}</span>`;
    }

    renderPriceBenefits() {
      return `
        <ul class="fa-fc__price-benefits" aria-label="${escapeHtml(this.t('benefits'))}">
          <li>${this.renderBenefitIcon('delivery')}<span>${escapeHtml(this.t('freeDelivery'))}</span></li>
          <li>${this.renderBenefitIcon('payment')}<span>${escapeHtml(this.t('invoiceOrCard'))}</span></li>
        </ul>
      `;
    }

    renderHelp(text) {
      const label = escapeHtml(text);
      return `<span class="fa-fc__help fa-fc__help--inline" tabindex="0" role="note" aria-label="${label}" data-help="${label}">?</span>`;
    }

    isInStock(item) {
      return Boolean(item && item.available) && Number(item.inventoryQuantity) > 0;
    }

    renderDeliveryStatus(item) {
      if (!this.isInStock(item)) return escapeHtml(this.t('availableByStock'));
      if (!this.config.deliveryEstimateUrl) return escapeHtml(this.t('deliveryUnavailable'));

      this.ensureDeliveryEstimate(item);
      if (item.deliveryText) return escapeHtml(item.deliveryText);
      if (item.deliveryError) return escapeHtml(this.t('deliveryReload'));
      return escapeHtml(this.t('deliveryLoading'));
    }

    async ensureDeliveryEstimate(item) {
      const endpoint = this.config.deliveryEstimateUrl;
      if (!endpoint || item.deliveryRequested || item.deliveryLoading || !this.isInStock(item)) return;

      item.deliveryRequested = true;
      item.deliveryLoading = true;
      item.deliveryError = false;
      const key = String(item.id || item.sku || item.formatKey || 'frame');
      const requestId = (this.deliveryRequestIds[key] || 0) + 1;
      this.deliveryRequestIds[key] = requestId;

      try {
        const response = await this.fetchWithTimeout(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(deliveryEstimatePayload(item, this.locale))
        }, 10000);
        const payload = await response.json().catch(() => ({}));
        if (this.deliveryRequestIds[key] !== requestId) return;
        if (!response.ok || !payload.ok) throw new Error(payload.message || this.t('deliveryReload'));

        item.deliveryText = String(payload.estimate && payload.estimate.deliveryText || '').trim()
          || this.t('deliveryUnavailable');
        item.deliveryError = false;
      } catch {
        if (this.deliveryRequestIds[key] !== requestId) return;
        item.deliveryText = '';
        item.deliveryError = true;
      } finally {
        if (this.deliveryRequestIds[key] === requestId) {
          item.deliveryLoading = false;
          // A delivery response must not replace an in-flight cart button/status
          // (or reset the customer's gallery/quantity selection).
          const selected = findFrame(this.items, this.state.width, this.state.height);
          const cell = selected === item && this.result && this.result.querySelector('.fa-fc__delivery-cell dd');
          if (cell) cell.innerHTML = this.renderDeliveryStatus(item);
        }
      }
    }

    async fetchWithTimeout(url, options, timeoutMs) {
      const controller = typeof globalScope.AbortController === 'function'
        ? new globalScope.AbortController()
        : null;
      const timer = controller && globalScope.setTimeout
        ? globalScope.setTimeout(() => controller.abort(), timeoutMs)
        : null;
      try {
        return await globalScope.fetch(url, {
          ...options,
          ...(controller ? { signal: controller.signal } : {})
        });
      } finally {
        if (timer && globalScope.clearTimeout) globalScope.clearTimeout(timer);
      }
    }

    renderMatch(item) {
      const media = this.renderProductMedia(item);
      const productTitle = item.productTitle || `${this.t('profileTitle')} ${item.shortSide}×${item.longSide} cm`;
      const quantity = Math.max(1, Number.parseInt(this.config.defaultQuantity, 10) || 1);
      const inStock = this.isInStock(item);
      const availabilityClass = inStock ? 'is-available' : 'is-unavailable';

      return `
        ${this.renderPreview()}
        <article class="fa-fc__product ${inStock ? '' : 'is-disabled'}">
          ${media}
          <div class="fa-fc__product-copy">
            <div class="fa-fc__product-kicker">${escapeHtml(this.t('resultTitle'))}</div>
            <h3>${escapeHtml(productTitle)}</h3>
            <dl>
              <div>
                <dt>${escapeHtml(this.t('productFormat'))}</dt>
                <dd>${item.shortSide} × ${item.longSide} cm</dd>
              </div>
              <div>
                <dt>${escapeHtml(this.t('finish'))}</dt>
                <dd>${escapeHtml(this.t('raw'))}</dd>
              </div>
              <div>
                <dt>${escapeHtml(this.t('sku'))}</dt>
                <dd>${escapeHtml(item.sku || '–')}</dd>
              </div>
              <div>
                <dt>${escapeHtml(this.t('availability'))}</dt>
                <dd><span class="fa-fc__stock ${availabilityClass}">${escapeHtml(inStock ? this.t('inStock') : this.t('outOfStock'))}</span></dd>
              </div>
              <div class="fa-fc__delivery-cell">
                <dt>${escapeHtml(this.t('deliveryDate'))} ${this.renderHelp(this.t('deliveryHelp'))}</dt>
                <dd>${this.renderDeliveryStatus(item)}</dd>
              </div>
            </dl>
            ${this.renderProductDescription(item)}
            <div class="fa-fc__price-box">
              ${this.renderPriceBenefits()}
              <div class="fa-fc__price">
                <span>${escapeHtml(this.t('price'))}</span>
                <strong>${escapeHtml(money(item.price, this.config.currency, this.locale))}</strong>
              </div>
            </div>
            ${inStock ? `
              <div class="fa-fc__buy">
                <label class="fa-fc__quantity">
                  <span>${escapeHtml(this.t('quantity'))}</span>
                  <input type="number" min="1" max="99" step="1" value="${quantity}" data-quantity>
                </label>
                <button type="button" class="fa-fc__cart-button" data-add-frame="${escapeHtml(item.id)}">
                  <span>${escapeHtml(this.t('addToCart'))}</span>
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7h13l-1.5 8h-10zM7 7 6 3H3M9 20h.01M18 20h.01"/></svg>
                </button>
              </div>
            ` : ''}
            <div class="fa-fc__product-actions">
              ${item.url ? `<a href="${escapeHtml(item.url)}">${escapeHtml(this.t('viewProduct'))}</a>` : ''}
            </div>
            ${this.renderShareButton(item)}
            <div class="fa-fc__inline-status" data-inline-status aria-live="polite"></div>
          </div>
        </article>
      `;
    }

    renderShareButton(item) {
      const imageUrl = absoluteShareImageUrl(item && item.image, globalScope.location && globalScope.location.href);
      return `
        <div class="fa-fc__share" data-share-widget data-share-image="${escapeHtml(imageUrl)}" data-share-variant="${escapeHtml(item && item.id || '')}">
          <button type="button" class="fa-fc__share-trigger" data-share-config aria-label="${escapeHtml(this.t('shareTitle'))}" aria-expanded="false" data-share-tooltip="${escapeHtml(this.t('share'))}">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M12 4v11"></path>
              <path d="m7 9 5-5 5 5"></path>
              <path d="M5 13v5a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-5"></path>
            </svg>
          </button>
          <div class="fa-fc__share-popover" data-share-popover hidden>
            <strong>${escapeHtml(this.t('shareTitle'))}</strong>
            <button type="button" data-share-option="whatsapp">${escapeHtml(this.t('shareWhatsApp'))}</button>
            <button type="button" data-share-option="email">${escapeHtml(this.t('shareEmail'))}</button>
            <button type="button" data-share-option="copy">${escapeHtml(this.t('shareCopy'))}</button>
            <div class="fa-fc__share-status" data-share-status hidden aria-live="polite"></div>
          </div>
        </div>
      `;
    }

    toggleShareWidget(button) {
      const widget = button.closest('[data-share-widget]');
      const popover = widget && widget.querySelector('[data-share-popover]');
      if (!widget || !popover) return;

      const willOpen = popover.hidden;
      this.closeShareWidgets(widget);
      popover.hidden = !willOpen;
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      this.setShareStatus(widget, '', '');
    }

    closeShareWidgets(except) {
      this.querySelectorAll('[data-share-widget]').forEach((widget) => {
        if (widget === except) return;
        const popover = widget.querySelector('[data-share-popover]');
        const trigger = widget.querySelector('[data-share-config]');
        if (popover) popover.hidden = true;
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    shareConfigUrl() {
      return buildFrameShareUrl(globalScope.location && globalScope.location.href, this.state);
    }

    shareConfigText() {
      const item = findFrame(this.items, this.state.width, this.state.height);
      const title = item && item.productTitle || this.t('profileTitle');
      return `${title}: ${this.state.width} × ${this.state.height} cm`;
    }

    async resolvedShareConfigUrl(widget) {
      const fallbackUrl = this.shareConfigUrl();
      const endpoint = String(this.config.shareShortlinkUrl || '').trim();
      if (!endpoint || !fallbackUrl) return fallbackUrl;

      const payload = frameSharePayload({
        locale: this.locale,
        href: globalScope.location && globalScope.location.href,
        state: this.state,
        variantId: widget && widget.dataset.shareVariant,
        imageUrl: widget && widget.dataset.shareImage,
        title: this.shareConfigText(),
        description: this.t('shareDescription')
      });

      try {
        const response = await this.fetchWithTimeout(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify(payload)
        }, 7000);
        const result = await response.json().catch(() => ({}));
        const shortUrl = String(result && result.url || '').trim();
        return response.ok && result.ok && shortUrl ? shortUrl : fallbackUrl;
      } catch {
        return fallbackUrl;
      }
    }

    async handleShareOptionClick(optionButton) {
      const widget = optionButton.closest('[data-share-widget]');
      const action = String(optionButton.dataset.shareOption || '');
      if (!widget || !action) return;

      const buttons = widget.querySelectorAll('[data-share-option]');
      buttons.forEach((button) => { button.disabled = true; });
      this.setShareStatus(widget, this.t('sharePreparing'), 'loading');

      try {
        const url = await this.resolvedShareConfigUrl(widget);
        if (!url) throw new Error('share url unavailable');
        const shareText = this.shareConfigText();

        if (action === 'whatsapp') {
          const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${shareText}\n${url}`)}`;
          const popup = globalScope.open && globalScope.open(whatsappUrl, '_blank', 'noopener');
          if (!popup && globalScope.location) globalScope.location.href = whatsappUrl;
          this.setShareStatus(widget, this.t('shareWhatsAppOpening'), 'success');
        } else if (action === 'email') {
          const mailtoUrl = `mailto:?subject=${encodeURIComponent(this.t('shareSubject'))}&body=${encodeURIComponent(`${shareText}\n\n${url}`)}`;
          if (globalScope.location) globalScope.location.href = mailtoUrl;
          this.setShareStatus(widget, this.t('shareEmailPreparing'), 'success');
        } else {
          await this.copyShareUrl(url, widget);
        }
      } catch {
        this.setShareStatus(widget, this.t('sharePrepareFailed'), 'error');
      } finally {
        if (globalScope.setTimeout) {
          globalScope.setTimeout(() => {
            buttons.forEach((button) => {
              if (button.isConnected) button.disabled = false;
            });
          }, 600);
        }
      }
    }

    async copyShareUrl(url, widget) {
      try {
        if (!globalScope.navigator || !globalScope.navigator.clipboard || !globalScope.navigator.clipboard.writeText) {
          throw new Error('clipboard unavailable');
        }
        await globalScope.navigator.clipboard.writeText(url);
        this.setShareStatus(widget, this.t('shareCopied'), 'success');
      } catch {
        this.setShareStatus(widget, `
          <span>${escapeHtml(this.t('shareManualCopy'))}</span>
          <input type="text" readonly value="${escapeHtml(url)}" onfocus="this.select()">
        `, 'manual', true);
      }
    }

    setShareStatus(widget, message, type, isHtml) {
      const status = widget && widget.querySelector('[data-share-status]');
      if (!status) return;
      status.hidden = !message;
      status.className = `fa-fc__share-status ${type ? `fa-fc__share-status--${type}` : ''}`;
      if (isHtml) status.innerHTML = message;
      else status.textContent = message;
    }

    async addToCart(button) {
      const item = this.items.find((candidate) => String(candidate.id) === String(button.dataset.addFrame));
      if (!item || !item.available || button.disabled) return;

      const quantityInput = button.closest('.fa-fc__product') && button.closest('.fa-fc__product').querySelector('[data-quantity]');
      const quantity = Math.max(1, Math.min(99, Number.parseInt(quantityInput && quantityInput.value, 10) || 1));
      const status = button.closest('.fa-fc__product') && button.closest('.fa-fc__product').querySelector('[data-inline-status]');
      const original = button.querySelector('span');

      button.disabled = true;
      if (original) original.textContent = this.t('adding');
      if (status) status.innerHTML = '';

      try {
        const response = await globalScope.fetch(this.config.cartAddUrl || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(item.id),
            quantity
          })
        });

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.description || payload.message || this.t('cartError'));
        }

        let cart = await globalScope.fetch(this.config.cartUrl || '/cart.js')
          .then((cartResponse) => cartResponse.ok ? cartResponse.json() : null)
          .catch(() => null);

        if (globalScope.FleuryFrameCartMerge && cart && cart.items?.some((line) => line.properties?._konfigurator === 'schattenfugenrahmen')) {
          // Older carts can contain this same fixed variant with obsolete private
          // properties. Consolidate before publishing the updated cart to the theme.
          cart = await globalScope.FleuryFrameCartMerge.reconcile({ publish: false }).catch(() => null) || cart;
        }

        if (globalScope.document) {
          globalScope.document.dispatchEvent(new globalScope.CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: this.dataset.sectionId,
              data: {
                source: 'frame-configurator',
                variantId: item.id,
                itemCount: cart && cart.item_count
              }
            }
          }));
          globalScope.document.querySelector('cart-drawer-component')?.open?.();
        }

        if (status) {
          status.className = 'fa-fc__inline-status is-success';
          status.innerHTML = `
            <span>${escapeHtml(this.t('added'))}</span>
            <a href="${escapeHtml(this.config.cartPageUrl || '/cart')}">${escapeHtml(this.t('goToCart'))}</a>
          `;
        }
      } catch (error) {
        button.disabled = false;
        if (status) {
          status.className = 'fa-fc__inline-status is-error';
          status.textContent = error && error.message ? error.message : this.t('cartError');
        }
      } finally {
        if (original) original.textContent = this.t('addToCart');
      }
    }
  }

  const api = {
    SUPPORTED_LOCALES,
    COPY,
    normalizeLocale,
    translate,
    applyDescriptionTemplate,
    parseTitleDimensions,
    parseSkuDimensions,
    extractDimensions,
    formatKey,
    isFrameProduct,
    normalizeFrameItems,
    availableCombos,
    axisOptions,
    nearestValue,
    nearestCombo,
    findFrame,
    parseQuickSizes,
    parseSharedFrameState,
    buildFrameShareUrl,
    absoluteShareImageUrl,
    frameShareParams,
    frameSharePayload,
    deliveryEstimatePayload,
    money,
    previewGeometry,
    galleryPhotos,
    FleuryFrameConfigurator
  };

  globalScope.FleuryFrameConfigurator = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (globalScope.customElements && !globalScope.customElements.get('fleury-frame-configurator')) {
    globalScope.customElements.define('fleury-frame-configurator', FleuryFrameConfigurator);
  }
}(typeof window !== 'undefined' ? window : globalThis));
